import React, {useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import {ChangePhoneNumberStep, MessageContent} from './Constant/Constant';
import {getReportParams, report} from 'app/middleware/report';
import {
  setCurrentStep,
  resetState,
  setShowPopUp,
  setEpiData,
  saveToHistory,
  setGeneralMessage,
  setSelectedAccount,
  submitAccountValidation,
} from './changePhoneNumberSlice';
import {Onboarding} from '../../Page/SelfCarePage/SelfCareAsyncThunk';
import {hideAppLoader, showAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import GeneralMessage from './Steps/GeneralMessage';
import SelectAccount from './Steps/SelectAccount';
import SelectNewNumber from './Steps/SelectNewNumber';
import CheckoutSummary from './Steps/CheckoutSummary';
import SuccessPage from './Steps/SuccessPage';
import CallBackPage from './Steps/CallBackPage';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import PopupWrapper from './Popup/PopupWrapper';
import useExtendedEffect from 'app/utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from 'app/utilities/hooks/useClearStateResetFlag';
import BackButton from 'app/Components/Shared/BackButton/BackButton';

const ChangePhoneNumberMain = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      let reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'PhoneNumberChange';
      reportParams.channel = 'WebsitePrivate';
      reportParams.actionType = 'PhoneNumberChangePage';
      reportParams.status = 'Ongoing';
      reportParams.messageText = 'PhoneNumberChangePage Displayed';
      reportParams.idNumber = props.authentication.loginData?.userDetails?.IDNumber;
      reportParams.customerName = `${props.authentication.loginData?.userDetails?.firstName} ${props.authentication.loginData?.userDetails?.lastName}`;
      reportParams.subscriber = props.authentication.loginData?.userDetails?.contactNumber;
      report(reportParams);
    }
  }, []);

  useEffect(() => {
    if (props.changePhoneNumber.newNumbersData.length === 0) {
      props.setEpiData(props.iContent);
    }
    return () => {
      props.resetState();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.changePhoneNumber.currentStep]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        props.saveToHistory(props.changePhoneNumber.currentStep);
      }
    },
    [props.changePhoneNumber.currentStep],
  );

  useEffect(() => {
    if (!props.changePhoneNumber.currentStep) {
      if (props.authentication.isAuthenticateFinish && props.productsAndServices.subscribersByProduct?.length != 0) {
        props.hideAppLoader();
        if (
          !props.productsAndServices?.subscribersByProduct?.Cellular ||
          props.productsAndServices?.subscribersByProduct?.Cellular?.length == 0
        ) {
          props.setGeneralMessage(MessageContent.NoNumbersError);
        } else if (props.productsAndServices?.subscribersByProduct?.Cellular?.length > 1) {
          props.setCurrentStep(ChangePhoneNumberStep.SelectAccount);
        } else {
          props.setSelectedAccount(props.productsAndServices.subscribersByProduct?.Cellular[0]);
          props.submitAccountValidation({subscriberNo: props.productsAndServices.subscribersByProduct?.Cellular[0]?.productSubscriberNo});
        }
      } else {
        props.showAppLoader();
        if (props.productsAndServices.subscribersByProduct == null) {
          props.Onboarding();
        }
      }
    }
  }, [props.authentication, props.productsAndServices]);

  const generalMessageActions = {
    privateLobby: () => EpiContext.navigateTo(Config.lobbyUrl),
    goToDebtPayment: () => EpiContext.navigateTo(props.changePhoneNumber.debtPaymentUrl),
    goToUpdatePaymentPage: () => EpiContext.navigateTo(props.changePhoneNumber.updatePaymentUrl),
    goToSale: () => EpiContext.navigateTo(props.changePhoneNumber.saleUrl),
  };

  let currentStep = () => {
    switch (props.changePhoneNumber.currentStep) {
      case ChangePhoneNumberStep.SelectAccount:
        return <SelectAccount />;
      case ChangePhoneNumberStep.SelectNewNumber:
        return <SelectNewNumber />;
      case ChangePhoneNumberStep.CheckoutSummary:
        return <CheckoutSummary />;
      case ChangePhoneNumberStep.Success:
        return <SuccessPage />;
      case ChangePhoneNumberStep.CallBack:
        return <CallBackPage />;
      case ChangePhoneNumberStep.GeneralMessage:
        return (
          <GeneralMessage
            messageData={props.changePhoneNumber.generalMessage}
            buttonClick={generalMessageActions[props.changePhoneNumber.generalMessage?.buttonClick]}
            whiteButtonClick={generalMessageActions[props.changePhoneNumber.generalMessage?.whiteButtonClick]}
            linkAction={generalMessageActions[props.changePhoneNumber.generalMessage?.linkAction]}
            secondLinkAction={generalMessageActions[props.changePhoneNumber.generalMessage?.secondLinkAction]}
            iContent={props.iContent}
          />
        );
      default:
        break;
    }
  };

  const getPreviousStep = () => {
    switch (props.changePhoneNumber.currentStep) {
      case ChangePhoneNumberStep.SelectNewNumber:
        return ChangePhoneNumberStep.SelectAccount;
      case ChangePhoneNumberStep.CheckoutSummary:
        return ChangePhoneNumberStep.SelectNewNumber;
    }
  };
  useClearStateResetFlag();

  return (
    <>
      {(props.changePhoneNumber.currentStep == ChangePhoneNumberStep.SelectNewNumber ||
        props.changePhoneNumber.currentStep == ChangePhoneNumberStep.CheckoutSummary) && (
        <BackButton onClick={() => props.setCurrentStep(getPreviousStep())} />
      )}
      <div className='change-phone-number'>
        {currentStep()}
        <div className='change-phone-number-popup-wrapper'>
          {props.changePhoneNumber.showPopup && (
            <PopUp showPopUp={props.changePhoneNumber.showPopup} onClose={() => props.setShowPopUp(false)}>
              <PopupWrapper data={props.changePhoneNumber.currentPopupData} />
            </PopUp>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
  authentication: state.authentication,
  productsAndServices: state.selfcarePage,
});

const mapDispatchToProps = {
  resetState,
  setCurrentStep,
  setShowPopUp,
  setEpiData,
  showAppLoader,
  hideAppLoader,
  Onboarding,
  saveToHistory,
  setGeneralMessage,
  setSelectedAccount,
  submitAccountValidation,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePhoneNumberMain);
